import { render, staticRenderFns } from "./VolunteerInfoCard.vue?vue&type=template&id=a27a058a&scoped=true"
import script from "./VolunteerInfoCard.vue?vue&type=script&lang=js"
export * from "./VolunteerInfoCard.vue?vue&type=script&lang=js"
import style0 from "./VolunteerInfoCard.vue?vue&type=style&index=0&id=a27a058a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27a058a",
  null
  
)

export default component.exports